
document.addEventListener('DOMContentLoaded', () => {
  const selector = document.querySelector('.club-jersey-selector');
  if (!selector) return;

  const isHomepage =
    Boolean(document.querySelector('home-club-hub')) ||
    document.querySelector('#MainContent')?.dataset.template === 'index';

  let selectedHandle = isHomepage
    ? new URLSearchParams(window.location.search).get('club')
    : null;

  const getDetail = (link) => ({
    handle: link.dataset.clubHandle,
    name: link.dataset.clubName,
    primary: link.dataset.clubPrimary,
    secondary: link.dataset.clubSecondary,
  });

  const dispatch = (name, detail) => {
    document.dispatchEvent(new CustomEvent(name, { detail, bubbles: true }));
  };

  const setActiveLink = (handle) => {
    if (!isHomepage) return;

    selector.classList.toggle('is-club-selected', Boolean(handle));
    selector.querySelectorAll('[data-club-handle]').forEach((link) => {
      const isActive = Boolean(handle) && link.dataset.clubHandle === handle;
      link.classList.toggle('is-active', isActive);

      if (isActive && link.dataset.clubPrimary) {
        link.style.setProperty('--club-primary', link.dataset.clubPrimary);
      } else {
        link.style.removeProperty('--club-primary');
      }
    });
  };

  const clearSelection = () => {
    selectedHandle = null;
    setActiveLink(null);

    const url = new URL(window.location.href);
    url.searchParams.delete('club');
    window.history.pushState({}, '', url);

    dispatch('brentbear:club-clear');
  };

  const selectClub = (link) => {
    selectedHandle = link.dataset.clubHandle;
    setActiveLink(selectedHandle);

    const url = new URL(window.location.href);
    url.searchParams.set('club', selectedHandle);
    window.history.pushState({ club: selectedHandle }, '', url);

    dispatch('brentbear:club-select', getDetail(link));
  };

  selector.querySelectorAll('[data-club-handle]').forEach((link) => {
    link.addEventListener('mouseenter', () => {
      if (!isHomepage || selectedHandle) return;
      dispatch('brentbear:club-preview', getDetail(link));
    });

    link.addEventListener('click', (event) => {
      if (!isHomepage) return;

      event.preventDefault();

      if (selectedHandle === link.dataset.clubHandle) {
        clearSelection();
        return;
      }

      selectClub(link);
    });
  });

  selector.addEventListener('mouseleave', (event) => {
    if (!isHomepage || selectedHandle) return;

    const nextTarget = event.relatedTarget;
    if (nextTarget instanceof Node && selector.contains(nextTarget)) return;

    dispatch('brentbear:club-clear');
  });

  if (isHomepage && selectedHandle) {
    const active = selector.querySelector(`[data-club-handle="${selectedHandle}"]`);
    if (active) {
      setActiveLink(selectedHandle);
      dispatch('brentbear:club-select', getDetail(active));
    }
  } else {
    setActiveLink(null);
  }

  window.addEventListener('popstate', () => {
    if (!isHomepage) return;

    selectedHandle = new URLSearchParams(window.location.search).get('club');
    setActiveLink(selectedHandle);

    if (selectedHandle) {
      const active = selector.querySelector(`[data-club-handle="${selectedHandle}"]`);
      if (active) dispatch('brentbear:club-select', getDetail(active));
    } else {
      dispatch('brentbear:club-clear');
    }
  });
});
